import * as React from 'react';
import { closest, isNullOrUndefined } from '@syncfusion/ej2-base';
import { GridComponent, ColumnsDirective, ColumnDirective, Inject, Filter, VirtualScroll, InfiniteScroll, Sort, Resize } from '@syncfusion/ej2-react-grids';
import { RatingComponent } from '@syncfusion/ej2-react-inputs';
import { DataManager, Query, UrlAdaptor, WebApiAdaptor } from '@syncfusion/ej2-data';
import { useSearchParams } from 'react-router-dom';
import './DtaGrid.css';
class CustomUrlAdaptor extends UrlAdaptor {


    processResponse(result, ds, query, action) {
        return {
            result: result.result.items || [],
            count: result.result.totalCount || 0
        };
    }
}

function statusTemplate(props) {
    return (<div>{props.Status === "Active" ?
        <div id="status" className="statustemp e-activecolor">
            <span className="statustxt e-activecolor">{props.Status}</span>
        </div> :
        <div id="status" className="statustemp e-inactivecolor">
            <span className="statustxt e-inactivecolor">{props.Status}</span>
        </div>}</div>);
}
function ratingTemplate(props) {
    return (<div><RatingComponent value={props.Rating} cssClass={'custom-rating'} readOnly={true} /></div>);
}
function progessTemplate(props) {
    let percentage = props[props.column.field];
    if (percentage <= 20) {
        percentage = percentage + 30;
    }
    return (<div id="myProgress" className="pbar">
        {props.Status === "Inactive" ?
            <div id="myBar" className="bar progressdisable" style={{ width: percentage + "%" }}>
                <div id="pbarlabel" className="barlabel">{percentage + "%"}</div>
            </div> :
            <div id="myBar" className="bar" style={{ width: percentage + "%" }}>
                <div id="pbarlabel" className="barlabel">{percentage + "%"}</div>
            </div>}
    </div>);
}
let loc = { width: '31px', height: '24px' };
function trustTemplate(props) {
    var Trustworthiness = props.Trustworthiness == "Sufficient" ? 'src/grid/images/Sufficient.png' : props.Trustworthiness == "Insufficient" ? 'src/grid/images/Insufficient.png' : 'src/grid/images/Perfect.png';
    return (<div> <img style={loc} src={Trustworthiness} alt="" />
        <span id="Trusttext">{props.Trustworthiness}</span></div>);
}
function empTemplate(props) {
    return (<div>
        {props.EmployeeImg === 'usermale' ?
            <div className="empimg">
                <span className="e-userimg sf-icon-Male" />
            </div> :
            <div className="empimg">
                <span className="e-userimg sf-icon-FeMale" />
            </div>}
        <span id="Emptext">{props.Employees}</span>
    </div>);
}
function coltemplate(props) {
    return (<div className="Mapimage">
        <img src="src/grid/images/Map.png" className="e-image" alt="" /> <span>  </span>
        <span id="locationtext">{props.Location}</span>
    </div>);
}
function trustdetails(props) {
    if (props.Trustworthiness === "Select All") {
        return (<span></span>);
    }
    let loc = { width: '31px', height: '24px' };
    let Trustworthiness = props.Trustworthiness == "Sufficient" ? 'src/grid/images/Sufficient.png' : props.Trustworthiness == "Insufficient" ? 'src/grid/images/Insufficient.png' : 'src/grid/images/Perfect.png';
    return (<div><img style={loc} src={Trustworthiness} alt="" /> <span id="Trusttext">{props.Trustworthiness}</span></div>);
}
function ratingDetails(props) {
    return (<RatingComponent value={props.Rating} cssClass={'custom-rating'} readOnly={true} />);
}
function statusdetails(props) {
    if (props.Status === "Select All") {
        return (<span>Select All</span>);
    }
    if (props.Status === "Active") {
        return (<div className="statustemp e-activecolor">
            <span className="statustxt e-activecolor">Active</span>
        </div>);
    }
    if (props.Status === "Inactive") {
        return (<div className="statustemp e-inactivecolor">
            <span className="statustxt e-inactivecolor">Inactive</span>
        </div>);
    }
}
function DataGrid() {
    let dReady = false;
    let isDataChanged = true;
    let intervalFun;
    let clrIntervalFun;
    let clrIntervalFun2;
    let ddObj;
    let gridInstance;
    let stTime;
    function onDataBound() {
        clearTimeout(clrIntervalFun);
        clearInterval(intervalFun);
    }
    function onComplete(args) {
        if (args.requestType === "filterchoicerequest") {
            if (args.filterModel.options.field === "Trustworthiness" || args.filterModel.options.field === "Rating" || args.filterModel.options.field === "Status") {
                var span = args.filterModel.dialogObj.element.querySelectorAll('.e-selectall')[0];
                if (!isNullOrUndefined(span)) {
                    closest(span, '.e-ftrchk').classList.add("e-hide");
                }
            }
        }
    }
    const [searchParams] = useSearchParams();
    const hostUrl = window.location.origin + '/api/v1/ReadExcel';
    const data = new DataManager({ url: hostUrl, adaptor: new CustomUrlAdaptor });
    const query = new Query().addParams('tenantId', searchParams.get('tenantId'))
        .addParams("documentId", searchParams.get('documentId'))
        .addParams("databaseContentId", searchParams.get('databaseContentId'));
    function onChange() {
        ddObj.hidePopup();
        let index = ddObj.value;
        clearTimeout(clrIntervalFun2);
        clrIntervalFun2 = setTimeout(() => {
            isDataChanged = true;
            stTime = null;
            let contentElement = gridInstance.contentModule.getPanel().firstChild;
            contentElement.scrollLeft = 0;
            contentElement.scrollTop = 0;
            gridInstance.pageSettings.currentPage = 1;
            stTime = performance.now();
            if (gridInstance.query.params.length > 1) {
                for (let i = 0; i < gridInstance.query.params.length; i++) {
                    if (gridInstance.query.params[i].key === 'dataCount') {
                        gridInstance.query.params[i].value = index.toString();
                        break;
                    }
                }
            }
            else {
                gridInstance.query.params[0].value = index.toString();
            }
            gridInstance.setProperties({ dataSource: data });
        }, 200);
    }
    const select = {
        persistSelection: true,
        type: "Multiple",
        checkboxOnly: true
    };
    function onLoad(args) {
        document.getElementById('overviewgrid').ej2_instances[0].on('data-ready', () => {
            dReady = true;
            stTime = performance.now();
        });
        var observer = new MutationObserver((mutations) => {
            mutations.forEach(() => {
                if (dReady && stTime && isDataChanged) {
                    stTime = null;
                    dReady = false;
                    isDataChanged = false;
                }
            });
        });
        observer.observe(document.getElementById('overviewgrid'), {
            attributes: true,
            childList: true,
            subtree: true,
        });
    }
    const gridFilter = {
        type: 'Menu'
    };


    return (
        <div className='control-pane'>
            <div className='control-section vh-100'>
                <GridComponent id="overviewgrid" allowResizing={false} allowTextWrap={false} clipMode='EllipsisWithTooltip'
                    enableInfiniteScrolling={false} pageSettings={{ pageSize: 100 }}
                    dataSource={data} loadingIndicator={{ indicatorType: 'Shimmer' }}
                    query={query}
                    enableHover={true}
                    enableVirtualization={true} rowHeight={38} height='100%'
                    ref={(g) => { gridInstance = g; }}
                    actionComplete={onComplete.bind(this)}
                    load={onLoad.bind(this)}
                    dataBound={onDataBound.bind(this)} filterSettings={gridFilter}
                    allowFiltering={false} allowSorting={false} allowSelection={true} selectionSettings={select}>
                    <Inject services={[Filter, VirtualScroll, InfiniteScroll, Sort, Resize]} />
                </GridComponent>
            </div>
        </div>
    );
}
export default DataGrid;